import React, { forwardRef } from 'react';

import * as RadixPopover from '@radix-ui/react-popover';
import styled from 'styled-components';

interface IPopoverProps extends RadixPopover.PopoverProps {
    id?: string
    modal?: boolean,
    showClose?: boolean
    showArrow?: boolean,
}

/*
 * [AL-3260] Portado no body, então empilha contra o StyledModal (1000) — em 6 o
 * picker ficava atrás do overlay. Ladder: modal 1000 < 1100 < Select 1150/1200.
 */
const Content = styled(RadixPopover.Content)`
    z-index: 1100;
    padding: ${({ theme }) => theme.space.bee};
    border: 1px solid ${({ theme }) => theme.colors.gray500};
    background-color: ${({ theme }) => theme.colors.surface};
`;

const Trigger = styled(RadixPopover.Trigger)`
    border: none;
    background-color: transparent;
`;

const Popover = forwardRef<HTMLButtonElement, IPopoverProps>((props, ref) => {
    const {
        id,
        open,
        modal,
        children,
        showClose,
        showArrow,
        defaultOpen,
        onOpenChange
    } = props;

    const popoverId = id ? `popover-${id}` : 'popover';

    return (
        <RadixPopover.Root
            open={open}
            modal={modal}
            defaultOpen={defaultOpen}
            onOpenChange={onOpenChange}
        >
            <Trigger
                id={id}
                ref={ref}
                aria-hidden="true"
                tabIndex={-1}
                data-cy={`${popoverId}-trigger`}
            />

            <RadixPopover.Portal id='popover-portal'>
                <Content id={popoverId} data-cy={popoverId}>
                    {showClose && <RadixPopover.Close data-cy={`${popoverId}-close`} />}
                    {showArrow && <RadixPopover.Arrow data-cy={`${popoverId}-arrow`} />}

                    {children}
                </Content>
            </RadixPopover.Portal>
        </RadixPopover.Root>
    );
});

Popover.defaultProps = {
    id: undefined,
    showClose: false,
    showArrow: false
};

export default Popover;
